(() => {
  function setupGallery(root) {
    if (root.dataset.irGalleryReady === 'true') return;
    root.dataset.irGalleryReady = 'true';
    const overlay = root.querySelector('[data-ir-overlay]');
    const dialog = root.querySelector('[data-ir-dialog]');
    const body = root.querySelector('[data-ir-modal-body]');
    let trigger = null;
    let index = 0;
    let oldOverflow = '';
    function slides() { return Array.from(body.querySelectorAll('[data-ir-slide]')); }
    function showSlide(next) {
      const items = slides();
      if (!items.length) return;
      index = (next + items.length) % items.length;
      items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      const counter = body.querySelector('[data-ir-counter]');
      if (counter) counter.textContent = `${index + 1} / ${items.length}`;
    }
    function open(tile) {
      const template = tile.nextElementSibling;
      if (!template || !template.matches('[data-ir-gallery-content]')) return;
      trigger = tile;
      body.replaceChildren(template.content.cloneNode(true));
      index = 0;
      const controls = body.querySelector('[data-ir-controls]');
      if (controls) controls.hidden = slides().length <= 1;
      showSlide(0);
      overlay.hidden = false;
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.focus();
    }
    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      body.replaceChildren();
      document.body.style.overflow = oldOverflow;
      if (trigger && trigger.isConnected) trigger.focus();
      trigger = null;
    }
    root.addEventListener('click', (event) => {
      const tile = event.target.closest('[data-ir-gallery-open]');
      if (tile && root.contains(tile)) return open(tile);
      if (event.target.closest('[data-ir-close]')) return close();
      if (event.target.closest('[data-ir-prev]')) return showSlide(index - 1);
      if (event.target.closest('[data-ir-next]')) return showSlide(index + 1);
    });
    root.addEventListener('keydown', (event) => {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'ArrowLeft') showSlide(index - 1);
      if (event.key === 'ArrowRight') showSlide(index + 1);
      if (event.key === 'Tab') {
        const focusable = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]):not([hidden])')).filter(el => el.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }
  function init() { document.querySelectorAll('[data-ir-gallery]').forEach(setupGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
